module.exports = __webpack_public_path__ + "f4ed3620dd5d06518b74a5c0c7289d3d.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/header/horse-mobile.png
// module id = 973
// module chunks = 2